'use client';
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ProjectCard from '@/components/ProjectCard';

import { projectData } from '../data/projectData';

const uniqueCategories = [
  'tous',
  ...new Set(projectData.map((item) => item.category)),
];
// console.log(uniqueCategories);

const Projects = () => {
  const [categories, setCategories] = useState(uniqueCategories);
  const [category, setCategory] = useState('tous');
  const filteredProjects = projectData.filter((project) => {
    return category === 'tous'
      ? project
      : project.category === category;
  });

  return (
    <section className='min-h-screen pt-12 '>
      <div className='container mx-auto'>
        <h2 className='section-title mb-8 xl:mb-16 text-center mx-auto'>
          Mes réalisations
        </h2>
        {/* TABS  */}
        <Tabs defaultValue={category} className='mb-24 xl:mb-48'>
          <TabsList className='w-full grid h-full grid-cols-2 md:grid-cols-4 lg:max-w-[640px] mb-12 mx-auto'>
            {categories.map((category, index) => {
              return (
                <TabsTrigger
                  onClick={() => setCategory(category)}
                  value={category}
                  key={index}
                  className='capitalize w-auto md:w-auto'
                >
                  {category}
                </TabsTrigger>
              );
            })}
          </TabsList>
          <div className='text-lg xl:mt-8 grid grid-cols-1 lg:grid-cols-3 gap-4'>
            {filteredProjects.map((project, index) => {
              return (
                <TabsContent value={category} key={index}>
                  <ProjectCard project={project} />
                </TabsContent>
              );
            })}
          </div>
        </Tabs>
      </div>
    </section>
  );
};

export default Projects;
